import StorageIcon from '@mui/icons-material/Storage';
import CloudIcon from '@mui/icons-material/Cloud';
import RouterIcon from '@mui/icons-material/Router';
import LanguageIcon from '@mui/icons-material/Language';
import SettingsInputComponentIcon from '@mui/icons-material/SettingsInputComponent';

export const RESOURCE_TYPE_VALUES = {
    SERVER: 'server',
    DATABASE: 'database',
    FIREWALL: 'firewall',
    CDN: 'cdn',
    API: 'api',
    SERVICE: 'service',
};

export const RESOURCE_TYPE_CONFIG = {
    [RESOURCE_TYPE_VALUES.SERVER]: { label: 'Server', icon: StorageIcon, color: '#1976d2' },
    [RESOURCE_TYPE_VALUES.DATABASE]: { label: 'Database', icon: StorageIcon, color: '#7b1fa2' },
    [RESOURCE_TYPE_VALUES.FIREWALL]: { label: 'Firewall Port', icon: RouterIcon, color: '#d32f2f' },
    [RESOURCE_TYPE_VALUES.CDN]: { label: 'CDN', icon: CloudIcon, color: '#0288d1' },
    [RESOURCE_TYPE_VALUES.API]: { label: 'External API', icon: LanguageIcon, color: '#388e3c' },
    [RESOURCE_TYPE_VALUES.SERVICE]: { label: 'External Service', icon: SettingsInputComponentIcon, color: '#f57c00' },
};

export const RESOURCE_TYPE_OPTIONS = [
    { value: RESOURCE_TYPE_VALUES.SERVER, label: RESOURCE_TYPE_CONFIG[RESOURCE_TYPE_VALUES.SERVER].label },
    { value: RESOURCE_TYPE_VALUES.DATABASE, label: RESOURCE_TYPE_CONFIG[RESOURCE_TYPE_VALUES.DATABASE].label },
    { value: RESOURCE_TYPE_VALUES.FIREWALL, label: RESOURCE_TYPE_CONFIG[RESOURCE_TYPE_VALUES.FIREWALL].label },
    { value: RESOURCE_TYPE_VALUES.CDN, label: RESOURCE_TYPE_CONFIG[RESOURCE_TYPE_VALUES.CDN].label },
    { value: RESOURCE_TYPE_VALUES.API, label: RESOURCE_TYPE_CONFIG[RESOURCE_TYPE_VALUES.API].label },
    { value: RESOURCE_TYPE_VALUES.SERVICE, label: RESOURCE_TYPE_CONFIG[RESOURCE_TYPE_VALUES.SERVICE].label },
];
